import {Avatar, Button, DatePicker, Input, message, Modal, Radio} from 'antd'
import {
    course_class_getAbsenceRequestsForDate_Api,
    course_class_getAttendanceDetails_Api,
    course_class_setAttendanceStatus_Api,
} from 'apis'
import {getId} from 'apis/model/base'
import classNames from 'classnames'
import FieldsFactory from 'components/form/FieldsFactory'
import {ResetButton, SubmitButton} from 'components/form/FormActionBar'
import {createValue} from 'components/form/utils'
import Pure from 'components/Pure'
import {Formik, useFormikContext} from 'formik'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import withTranslate from 'modules/local/withTranslate'
import React, {useCallback, useContext, useEffect, useMemo, useRef, useState} from 'react'
import {BsQrCodeScan} from 'react-icons/bs'
import {
    IoBookOutline,
    IoCalendarOutline,
    IoCheckmarkCircle,
    IoCopyOutline,
    IoQrCodeOutline,
    IoSchoolOutline
} from 'react-icons/io5'
import {compose, mapProps, pure} from 'recompose'
import EntityList from 'views/AppLocals/EntityList'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {createControlledFormField} from 'views/AppLocals/factory/createFormField'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import {getResponseItems, NullAsDefault, renderIf, shallowDiff} from 'views/Shared'
import {attendance_status_options} from '..'
import {
    course_class_attendanceCheckIn_Api,
    course_class_getAttendanceDetailsByAuth_Api,
    course_class_getAttendanceDetailsByStudent_Api,
    course_class_student_getAttendanceResult_Api
} from '../../../../apis'
import {formatDate, getDateString, parseDayjs} from '../../../../helpers/datetimeHelpers'
import {gConfigs} from '../../configs'
import {createNumberControlledInput} from '../../factory/createFormField'
import {bindQueryParams} from '../../functions/routerHelper'
import {CourseClassTimetableDetailSelector} from '../components/CourseClassTimetableDetailSelector'
import CourseClassInformation from './CourseClassInformation'
import EmptyHolder, {renderEmptyHolder} from "../../../../components/EmptyHolder";
import {SubClassTags} from "../components/SubClassTags";
import {FaUserGraduate} from "react-icons/fa6";
import copyToClipboard from "copy-to-clipboard";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {useQrScanner} from "../../../../hooks/useQrScanner";
import getAvatar from "../../../../helpers/getAvatar";
import {showErrorDialog} from "../../factory/createErrorDialog";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {ObjectSelectField} from "../../../../components/form/fields/ObjectSelectField";
import {extractTypeAndIdFromUrl} from "../../../../helpers/stringUtils";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import getLabelOfGender from "../../../../helpers/getLabelOfGender";
import dayjs from "dayjs";
import {ActionModalWrapper} from "../../../../components/form/ActionModalWrapper";
import {Section} from "../../../../components/form/ModernForm";
import {LoginContext} from "../../../../components/LoginContext";
import AttendanceInput from "../../../../components/form/fields/AttendanceInput";
import {TbAlertTriangle} from "react-icons/tb";
import {DrawerBottomDialog} from "../../../../components/drawer/dialog/DrawerBottomDialog";
import {PiCheckLight} from "react-icons/pi";
import {MdEdit, MdOutlineCancel} from "react-icons/md";
import {ItemInformation} from "../../../../components/common/ItemInformation";
import {DatePlaceItem} from "../../../../components/common/DatePlaceItem";
import {GoDotFill} from "react-icons/go";
import {getInitials} from "../../../Workspace/Course/functions/renderStudent";
import {getGroupColor} from "../../../Workspace/Course/functions/renderCourseClassStudent";

const formSchema = {
    title: {
        title: 'title',
        children: [
            {
                description: 'create lesson description',
                name: 'title',
                isRequired: true,
                component: compose(
                    withTranslate,
                    mapProps(({name, value, translate, onChange}) => ({
                        name,
                        value,
                        onChange,
                        placeholder: translate('ex: dddd, DD/MM/YYYY'),
                        addonBefore: (
                            <span className="font-medium text-sm text-color-400 italic">
                {translate('lesson on')}
              </span>
                        ),
                    })),
                    pure
                )(Input),
            },
        ],
    },
    default_value: {
        title: 'default attendance status',
        description: 'default attendance status description',
        desClassName: 'text-xs text-color-400 italic mt-1.5 leading-relaxed',
        children: [
            {
                name: 'default_value',
                component: compose(
                    withTranslate,
                    mapProps(({translate, name, value, onChange}) => ({
                        name,
                        value,
                        onChange: onChange,
                        buttonStyle: 'solid',
                        className: 'custom-radio-button-sm',
                        defaultValue: 0,
                        children: [
                            {label: 'not check in', value: 0},
                            {label: 'in attendance', value: 1},
                            {label: 'unexcused absence', value: -2},
                        ].map(({value, label}) => (
                            <Radio.Button
                                key={value}
                                value={value}>
                                {translate(label)}
                            </Radio.Button>
                        )),
                    }))
                )(Radio.Group),
            },
        ],
    },
    status: {
        title: 'status',
        children: [
            {
                name: 'status',
                component: ({name, value, form, onChange}) => {
                    const options = Array.from(form?.values?.status_options ?? [])
                    return (
                        <Translate>
                            {(t) => (
                                <Radio.Group
                                    name={name}
                                    value={value}
                                    options={options.map(({value, label}) => ({
                                        value: value,
                                        label: (
                                            <span className="font-medium text-sm text-color-100 italic">
                                                {t(label)}
                                            </span>
                                        ),
                                    }))}
                                    className="mt-1 flex flex-col md:flex-row gap-2 custom-radio-button"
                                    onChange={(event) => {
                                        onChange(createValue(name, event.target.value))
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    attendance_state: {
        children: [
            {
                name: 'attendance_state',
                component: ({name, value, form, onChange}) => {
                    return (
                        <AttendanceInput
                            defaultValues={value}
                            onValuesChange={(values) => {
                                // values == null: người dùng bấm nút thùng rác để GỠ điểm danh.
                                // Trước đây chỉ spread {...null} nên status/số tiết/lý do ở cấp form
                                // vẫn giữ giá trị cũ -> bấm Lưu gửi lại đúng trạng thái cũ, "xóa
                                // điểm danh không được" (bug sếp báo). Phải reset hẳn về status 0
                                // = "Chưa xác định" (attendance_status_options.reset, BE
                                // setAttendanceStatus chấp nhận 0 và không tính vào chuyên cần).
                                // CHỈ status về 0 + xoá lý do; số tiết là thuộc tính của BUỔI HỌC
                                // (không phải chuyên cần từng học viên) nên GIỮ NGUYÊN giá trị mặc
                                // định đã truyền vào. attendance_state phải là object mang theo
                                // number_of_sessions - nếu để null thì AttendanceInput rơi vào
                                // fallback number_of_sessions: 1, stepper nhảy về 1.
                                if (values == null) {
                                    form.setValues({
                                        ...form.values,
                                        status: attendance_status_options.reset.value,
                                        absent_reason: undefined,
                                        attendance_state: {
                                            status: null,
                                            number_of_sessions: form.values.number_of_sessions,
                                            absent_reason: undefined,
                                        },
                                    })
                                    return
                                }
                                form.setValues({
                                    ...form.values,
                                    ...values,
                                    attendance_state: values
                                })
                            }}
                        />
                    )
                },
            },
        ],
    },
    absent_reason: {
        title: 'reason',
        children: [
            {
                name: 'absent_reason',
                component: createControlledFormField({
                    rows: 3,
                    placeholder: 'reason',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    course_subject__sessions: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'subjects',
                name: 'subject',
                component: mapProps(({name, value, form, onChange}) => {
                    const {subject_id, course_class} = form?.values ?? {}
                    const {class_subjects = []} = course_class;
                    const subjects = class_subjects.map(e => ({
                        id: e.subject.id,
                        value: e.subject.id,
                        label: e.subject.title,
                        ...e.subject
                    }));

                    return {
                        name,
                        onChange,
                        onOptionChange: (option) => {
                            // Ghi CẢ object `subject` (validate() bắt buộc subject?.id) LẪN `subject_id`
                            // - `value` bên dưới đọc lại từ subject.id nên chọn xong mới giữ được hiển thị.
                            onChange(createValue(name, option ?? null))
                            onChange(createValue('subject_id', option?.id ?? null))
                        },
                        value: form?.values?.subject?.id ?? subject_id,
                        showSearch: true,
                        options: subjects,
                        style: {
                            padding: 0,
                            border: 0,
                        }
                    }
                })(ObjectSelectField),
            },
            {
                label: 'number of sessions',
                name: 'number_of_sessions',
                component: createNumberControlledInput({
                    placeholder: 'number of sessions',
                }),
            },
        ],
    },
    course_subject__sessions__date: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        children: [
            {
                label: 'subjects',
                isRequired: true,
                name: 'subject',
                component: mapProps(({name, value, form, onChange}) => {
                    const {subject_id, course_class} = form?.values ?? {}
                    const {class_subjects = []} = course_class;
                    const subjects = class_subjects.map(e => ({
                        id: e.subject.id,
                        value: e.subject.id,
                        label: e.subject.title,
                        ...e.subject
                    }));
                    return {
                        name,
                        onChange,
                        onOptionChange: (option) => {
                            // Ghi CẢ object `subject` (validate() bắt buộc subject?.id) LẪN `subject_id`
                            // - `value` bên dưới đọc lại từ subject.id nên chọn xong mới giữ được hiển thị.
                            onChange(createValue(name, option ?? null))
                            onChange(createValue('subject_id', option?.id ?? null))
                        },
                        value: form?.values?.subject?.id ?? subject_id,
                        showSearch: true,
                        options: subjects,
                        style: {padding: 0, border: 0}
                    }
                })(ObjectSelectField),
            },
            {
                label: 'number of sessions',
                name: 'number_of_sessions',
                component: createNumberControlledInput({
                    placeholder: 'number of sessions',
                }),
            },
            {
                label: 'attendance date',
                name: 'attendance_date',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <DatePicker
                                key={value}
                                className="w-full"
                                suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                                allowClear={false}
                                format={gConfigs.dateFormat}
                                defaultValue={value}
                                placeholder={t('attendance date')}
                                onChange={(value) => {
                                    onChange(createValue(name, value))
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
    number_of_sessions: {
        title: 'number of sessions',
        children: [
            {
                name: 'number_of_sessions',
                component: createNumberControlledInput({
                    placeholder: 'number of sessions',
                }),
            },
        ],
    },
    course_class_timetable_detail: {
        title: 'timetables',
        description: 'timetable linking description',
        desClassName: 'text-xs text-color-400 italic mt-1.5 leading-relaxed',
        children: [
            {
                name: 'course_class_timetable_detail',
                component: compose(mapProps(({name, value, form, onChange}) => {
                    const {course_class_id, subject, subject_id, course_class_timetable_detail_id} = form?.values ?? {}
                    return {
                        name,
                        value,
                        onChange,
                        course_class_id,
                        subject_id: subject?.id || subject_id,
                        course_class_timetable_detail_id,
                        dependencies: [subject_id, course_class_id, course_class_timetable_detail_id]
                    }
                }), pure)
                (CourseClassTimetableDetailSelector),
            },
        ],
    },
    attendance_date: {
        title: 'attendance date',
        children: [
            {
                name: 'attendance_date',
                component: ({name, value, onChange}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <DatePicker
                                    key={value}
                                    className="w-full"
                                    suffixIcon={<IoCalendarOutline className="text-color-500"/>}
                                    allowClear={false}
                                    format={gConfigs.dateFormat}
                                    defaultValue={value}
                                    placeholder={t('attendance date')}
                                    onChange={(value) => {
                                        onChange(createValue(name, value))
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
}

export const getStatusConfig = (status) => {
    switch (status) {
        case -1:
        case -2:
            return {
                color: 'bg-red-50 text-red-600 border-red-400',
                icon: MdOutlineCancel,
                iconColor: 'text-red-500',
            };
        case -3:
            return {
                color: 'bg-yellow-50 text-yellow-600 border-yellow-400',
                icon: TbAlertTriangle,
                iconColor: 'text-yellow-500'
            };
        case 1:
            return {
                color: 'bg-green-50 text-green-600 border-green-400',
                icon: PiCheckLight,
                iconColor: 'text-green-500'
            };
        default:
            return {
                color: 'background-100 text-color-200 border-color-100',
                icon: PiCheckLight,
                iconColor: 'text-green-500'
            };
    }
};

const AttendanceStatusBadge = ({status}) => {
    const {color, icon: Icon, iconColor} = getStatusConfig(status);
    return (
        <div
            className={classNames("flex items-center space-x-2 px-3 py-1 rounded-full text-xs font-semibold shadow-sm", color)}>
            {/*<Icon size={14} className={iconColor}/>*/}
            <span>{getTitle({status})}</span>
        </div>
    );
};

/**
 * Redesigned component to render attendance detail item.
 * @param {Object} props
 * @param {function} props.renderActions - Function to render actions.
 * @param {string} props.primary_type - 'student' or 'session'.
 * @returns {function} The rendering function (item, index) => ReactElement
 */
export const renderAttendantDetail = ({renderActions = NullAsDefault, primary_type = 'student'} = {}) =>
    (item, index) => {
        const t = useTranslate();
        const {isLg} = useContext(LayoutContext);
        const {student, attendance, absent_reason, number_of_sessions, status: numStatus} = item ?? {};
        const {patron_saint_name, fullname, avatar, user, ref_id} = student ?? {};
        const initials = getInitials(fullname)
        const color = getGroupColor(fullname)

        // Event-style card for attendance sessions (student view)
        if (primary_type !== 'student') {
            const dateObj = attendance?.attendance_date ? dayjs(attendance.attendance_date) : null
            const hasTime = dateObj && (dateObj.hour() !== 0 || dateObj.minute() !== 0)

            let _color = 'background-100 text-color-100 border-color-100'

            if (numStatus === 1) {
                _color = 'bg-green-50 text-green-600 border-green-400'
            } else if (numStatus === -3) {
                _color = ' bg-yellow-50 text-yellow-600 border-yellow-400'
            } else if (numStatus === -1 || numStatus === -2 || absent_reason) {
                _color = 'bg-primary-50 text-primary-600 border-red-400'
            }

            return (
                <div key={index} className="p-3 flex items-center gap-3 border border-color-50 shadow-sm background rounded-xl 222-222">
                    {/* Date badge - event style */}
                    {dateObj && (
                        <div
                            style={{width: 64, height: 64}}
                            className={classNames(
                                "p-2 flex flex-col flex-center flex-shrink-0 rounded-xl border-2",
                                _color
                            )}>
                            <span className="font-bold text-xl leading-snug">
                                {dateObj.format('DD')}
                            </span>
                            <span className="font-medium text-xs text-slate-400 leading-tight mt-0.5">
                                {dateObj.format('MM/YYYY')}
                            </span>
                        </div>
                    )}

                    {/* Content */}
                    <div className="flex flex-col space-y-2 flex-1 min-w-0">
                        <span className="font-bold text-base text-gray-800 leading-tight truncate 111-111">
                            {getTitle(attendance)}
                        </span>
                        <div className="flex items-center gap-1.5 text-xs text-color-400 leading-tight">
                            {attendance?.subject && (
                                <span className="font-medium text-color-300">{getTitle(attendance.subject)}</span>
                            )}
                            {!!number_of_sessions && attendance?.subject && <GoDotFill size={10} className="ml-2 text-slate-400"/>}
                            {!!number_of_sessions && (
                                <span className="italic">{number_of_sessions} {t('sessions')}</span>
                            )}
                        </div>
                        {renderIf(absent_reason,
                            <div className="flex items-center gap-1 text-xs text-red-500 italic">
                                <TbAlertTriangle size={11} className="flex-shrink-0"/>
                                <span>{absent_reason}</span>
                            </div>
                        )}
                    </div>

                    {/* Status badge */}
                    <div className="flex flex-col items-center gap-1 flex-shrink-0">
                        {renderActions(item)}
                        {hasTime && (
                            <span className="font-medium text-xs text-color-400 italic tracking-wider leading-tight">
                                {dateObj.format('HH:mm')}
                            </span>
                        )}
                    </div>
                </div>
            )
        }

        // Admin/session view — compact table row (mobile stacked, desktop 5-col grid)
        const borderClass = numStatus === 1 ? 'border-green-400'
            : numStatus === -3 ? 'border-yellow-400'
            : numStatus === -1 ? 'border-orange-400'
            : numStatus === -2 ? 'border-primary-600'
            : 'border-color-100'

        const nameCell = (
            <div className="flex flex-col min-w-0 pr-2">
                <div className="flex items-center gap-0.5 font-semibold text-sm text-gray-800 truncate leading-snug">
                    {(avatar || user?.avatar ) ? (
                        <Avatar
                            size={28}
                            src={avatar || user?.avatar}
                            className="rounded-full"
                        />
                    ) : (
                        <div
                            style={{width: 28, height: 28, backgroundColor: color, flexShrink: 0}}
                            className="rounded-full flex flex-center">
                            <span className="text-white font-bold text-xs leading-none">{initials}</span>
                        </div>
                    )}
                    <span className={classNames("mx-1 h-6 border-l-4 rounded-full", borderClass)} />
                    <div className="flex flex-col flex-1">
                        <div className="space-x-1">
                            {patron_saint_name && (
                                <span className="font-medium text-slate-500 mr-1">
                                    {patron_saint_name}
                                </span>
                            )}
                            {fullname}
                        </div>
                        <div className="space-x-3">
                            <span
                                onClick={() => {
                                    copyToClipboard(student?.student_idcode)
                                    message.info(t('copied'))
                                }}
                                className="text-xs font-mono text-blue-500 hover:text-blue-600 truncate cursor-pointer pr-2 ">
                                {student?.student_idcode || '-'}
                                <IoCopyOutline size={12} className="ml-1"/>
                            </span>
                            {ref_id && (
                                <span className="text-2xs text-color-300 whitespace-no-wrap">
                                    {`Ref: ${ref_id}`}
                                </span>
                            )}
                        </div>
                    </div>
                </div>
                {absent_reason && (
                    <span className="ml-10 flex items-center gap-1 text-xs text-red-500 italic truncate leading-tight">
                        <TbAlertTriangle size={12} className="flex-shrink-0"/>
                        {absent_reason}
                    </span>
                )}
            </div>
        )

        return student && (
            <div key={index} className={classNames("border-b border-color-50 hover:background-50 transition-colors")}>
                {isLg ? (
                    <div className="grid items-center px-3 py-2" style={{gridTemplateColumns: '1fr 110px 64px 130px'}}>
                        {nameCell}
                        <span className="text-xs text-center text-color-300 truncate">{item?.sub_class_name || '-'}</span>
                        <span className="text-xs text-center font-medium text-color-200">{number_of_sessions || '-'}</span>
                        <div className="flex justify-center">{renderActions(item)}</div>
                    </div>
                ) : (
                    <div className="grid items-center px-3 py-2" style={{gridTemplateColumns: '1fr auto'}}>
                        <div className="flex flex-col gap-0.5 min-w-0 pr-2">
                            <span className="text-xs font-mono text-blue-500 leading-tight">
                                {student?.student_idcode || '-'}
                            </span>
                            {nameCell}
                            {item?.sub_class_name && (
                                <span className="text-xs text-color-400 italic">{item.sub_class_name}</span>
                            )}
                        </div>
                        <div className="flex-shrink-0">{renderActions(item)}</div>
                    </div>
                )}
            </div>
        )
    }

export const ATTENDANCE_STATUS_LABEL = {
    1:  'in attendance',
    '-1': 'excused absence',
    '-2': 'unexcused absence',
    '-3': 'late',
    0:  'undefined',
}

/**
 * Shared per-session attendance list.
 * readOnly=true  → student sees their own sessions (no edit controls).
 * readOnly=false → admin can change status (renderActions must be passed externally).
 * When student_id is provided → admin view using course_class_getAttendanceDetailsByStudent_Api.
 * When student_id is absent  → auth view using course_getAttendanceByStudentReportByAuth_Api.
 */
export const StudentAttendanceSessionList = ({course_class_id, student_id, readOnly = true}) => {
    const t = useTranslate()
    const login = useContext(LoginContext)

    const apiInfo = student_id
        ? course_class_getAttendanceDetailsByStudent_Api
        : course_class_getAttendanceDetailsByAuth_Api

    const query = bindQueryParam({id: course_class_id})

    const refreshKey = [course_class_id, student_id ?? 'auth'].join('/')

    const renderReadOnlyStatus = useCallback((item) => {
        const numStatus = item?.attendance?.status ?? item?.status
        const cfg = getStatusConfig(numStatus)
        const label = ATTENDANCE_STATUS_LABEL[numStatus] ?? 'undefined'

        return (
            <div className={classNames("px-3 py-0.5 flex flex-center rounded-lg font-semibold text-xs border flex-shrink-0", cfg.color)}>
                {t(label)}
            </div>
        )
    }, [t])

    return renderIf(
        login,
        <EntityList
            key={refreshKey}
            refreshKey={refreshKey}
            RenderEntity={React.Fragment}
            renderEmpty={() => <EmptyHolder title={null}/>}
            renderItem={renderAttendantDetail({
                primary_type: 'attendance',
                renderActions: readOnly ? renderReadOnlyStatus : NullAsDefault,
            })}
            renderWrap={(child) => (
                <div className="flex flex-col gap-4">
                    {child}
                </div>
            )}
            query={query}
            apiInfo={apiInfo}
        />
    )
}

const AbsenceRequestAlert = ({course_class_id, attendance_date}) => {
    const t = useTranslate()
    const [absenceList, setAbsenceList] = useState([])
    const prevDateRef = useRef(null)
    const [expanded, setExpanded] = useState(false)

    const {handleAsyncAction: fetchAbsenceRequests} = useAsyncAction({
        apiInfo: course_class_getAbsenceRequestsForDate_Api,
        onSuccess: (__, data) => {
            const items = Array.isArray(data?.response?.data?.data)
                ? data.response.data.data
                : []
            setAbsenceList(items)
        },
    })

    useEffect(() => {
        const dateStr = attendance_date ? getDateString(attendance_date) : null
        if (dateStr && dateStr !== prevDateRef.current && course_class_id) {
            prevDateRef.current = dateStr
            fetchAbsenceRequests({attendance_date: dateStr}, {id: course_class_id})
        }
        if (!dateStr) setAbsenceList([])
    }, [attendance_date, course_class_id])

    if (!absenceList.length) return null

    return (
        <div className="rounded-xl bg-amber-50 border border-amber-200 overflow-hidden">
            <button
                type="button"
                onClick={() => setExpanded(v => !v)}
                className="w-full px-3 py-2.5 flex items-center gap-2 text-left">
                <TbAlertTriangle size={15} className="text-amber-500 flex-shrink-0"/>
                <span className="flex-1 text-xs font-semibold text-amber-700">
                    {absenceList.length} {t('students have absence requests for this session')}
                </span>
                <span className="text-xs text-amber-500">{expanded ? '▲' : '▼'}</span>
            </button>
            {expanded && (
                <div className="px-3 pb-2 flex flex-col gap-1 border-t border-amber-200">
                    {absenceList.map((r) => (
                        <div key={r.id} className="flex items-center justify-between py-1 text-xs">
                            <span className="font-medium text-amber-800">{r.student?.fullname || '—'}</span>
                            <span className="text-amber-600 italic">{t(r.reason_group || 'no reason')}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

const AbsenceAlertWatcher = ({course_class_id}) => {
    const {values} = useFormikContext()
    return (
        <AbsenceRequestAlert
            course_class_id={course_class_id}
            attendance_date={values?.attendance_date}
        />
    )
}

export const CourseClassAttendanceCreateForm = ({
                                                    course_class,
                                                    initialValues,
                                                    onSubmit = NullAsDefault,
                                                    isSubmitting = false,
                                                }) => {
    const t = useTranslate()

    const course_id = getId(course_class?.course)

    const _initialValues = useMemo(
        () => {
            // Môn học giờ BẮT BUỘC (xem validate()). Lớp chỉ có đúng 1 môn -> chọn sẵn để form hợp lệ
            // ngay, người dùng không phải tự mở dropdown chọn lại đúng cái duy nhất.
            const soleSubject = course_class?.class_subjects?.length === 1
                ? course_class.class_subjects[0]?.subject
                : null
            return {
                course_id,
                title: _.capitalize(dayjs().format('dddd, DD/MM/YYYY')),
                default_value: 0,
                number_of_sessions: 1,
                attendance_date: dayjs(),
                course_class_id: course_class?.id,
                course_class,
                ...(soleSubject
                    ? {
                        subject: {...soleSubject, id: soleSubject.id, value: soleSubject.id, label: soleSubject.title},
                        subject_id: soleSubject.id,
                    }
                    : {}),
                ...(initialValues ?? {}),
            }
        },
        [course_id, course_class, initialValues]
    )

    const validate = (values) => {
        let errors = {}

        const {title, subject, subject_id} = values ?? {}

        if (_.isEmpty(title ?? '')) {
            errors.title = t('required field')
        }
        // Khi mở form từ "Tạo điểm danh" ở lịch học (MyClassSessionsPanel), giá trị chỉ được prefill
        // qua subject_id (chưa có object `subject` đầy đủ - người dùng chưa tự mở dropdown chọn lại) -
        // phải fallback về subject_id giống HỆT cách field tự resolve `value` để hiển thị (xem
        // course_subject__sessions__date ở trên), nếu không sẽ báo thiếu dù dropdown đang hiện đúng môn.
        if ((subject?.id ?? subject_id) === undefined) {
            errors.subject = t('required field')
        }

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const {
                    subject,
                    subject_id,
                    course_id,
                    attendance_date,
                    course_class_timetable_detail,
                    ...rest
                } = values ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            // Cùng fallback như validate() ở trên - subject?.id trước, subject_id
                            // (prefill sẵn từ nơi mở form, ví dụ MyClassSessionsPanel) sau. Trước đây ép
                            // cứng về null khi thiếu object `subject`, xoá mất giá trị subject_id đã
                            // prefill sẵn dù hợp lệ.
                            subject_id: subject?.id ?? subject_id ?? null,
                            course_class_timetable_detail_id: getId(
                                course_class_timetable_detail
                            ),
                            attendance_date: getDateString(attendance_date),
                        },
                        _.isUndefined
                    )
                )
            }}>
            <ActionModalWrapper
                className="gap-3"
                action={
                    <div className="flex items-center justify-end p-2 background gap-3">
                        <ResetButton disabled={isSubmitting}/>
                        <SubmitButton
                            label="create"
                            dirtyRequired={false}
                            loading={isSubmitting}
                        />
                    </div>
                }>
                <CourseClassInformation
                    item={course_class}
                    showDescription={false}
                />
                {/* Rule chung docs/ui/form-layout.md: Section highlight = nhóm bắt buộc trọng tâm,
                    neutral = còn lại. Field phức tạp (ObjectSelect môn học, DatePicker, selector thời
                    khoá biểu) TÁI DÙNG NGUYÊN qua FieldsFactory bên trong Section - không viết lại. */}
                <Pure>
                    {/* Mỗi field 1 FieldsFactory riêng để Section (gap-3) giãn cách - dồn chung thì
                        các field chỉ cách gap-1, dính sát khó đọc. */}
                    <div className="flex flex-col gap-4">
                        <Section icon={IoBookOutline} title={t('attendance information')} theme="highlight">
                            <FieldsFactory formSchema={[formSchema.title]}/>
                            <FieldsFactory formSchema={[formSchema.course_subject__sessions__date]}/>
                        </Section>
                        <Section icon={IoCalendarOutline} title={t('other information')} subtitle={t('optional')}>
                            <FieldsFactory formSchema={[formSchema.course_class_timetable_detail]}/>
                            <FieldsFactory formSchema={[formSchema.default_value]}/>
                        </Section>
                    </div>
                </Pure>
                {/* Absence alert — tự động cập nhật khi chọn ngày */}
                <AbsenceAlertWatcher course_class_id={course_class?.id}/>
            </ActionModalWrapper>
        </Formik>
    )
}

export const CourseClassAttendanceUpdateForm = ({
                                                    course_class,
                                                    initialValues,
                                                    onSubmit = NullAsDefault,
                                                    isSubmitting = false,
                                                }) => {
    const t = useTranslate()
    const course_id = getId(course_class?.course)
    const course_class_id = getId(course_class)
    const _initialValues = useMemo(() => {
        const {attendance_date, ...rest} = initialValues ?? {}
        return {
            course_id,
            course_class_id,
            subject_id: initialValues?.subject_id || initialValues?.subject?.id,
            course_class,
            attendance_date: parseDayjs(attendance_date),
            ...rest,
        }
    }, [course_id, course_class_id, initialValues]);

    const validate = (values) => {
        let errors = {}

        const {title} = values ?? {}

        if (_.isEmpty(title ?? '')) {
            errors.title = t('required field')
        }

        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={_initialValues}
            onSubmit={(values) => {
                const changes = shallowDiff(values, _initialValues)
                const {
                    subject,
                    course_id,
                    attendance_date,
                    course_class_timetable_detail,
                    ...rest
                } = changes ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            subject_id: values?.subject ? getId(subject) : null,
                            attendance_date: getDateString(attendance_date),
                            course_class_timetable_detail_id:
                                values?.course_class_timetable_detail
                                    ? getId(course_class_timetable_detail)
                                    : null,
                        },
                        _.isUndefined
                    )
                )
            }}>
            <ActionModalWrapper
                className="gap-4"
                action={
                    <div className="flex items-center justify-end p-2 background gap-3">
                        <ResetButton disabled={isSubmitting}/>
                        <SubmitButton
                            label="save"
                            dirtyRequired={false}
                            loading={isSubmitting}
                        />
                    </div>
                }>
                <CourseClassInformation
                    item={course_class}
                    showDescription={false}
                />
                <Pure>
                    <FieldsFactory
                        formSchema={[
                            formSchema.title,
                            formSchema.course_subject__sessions__date,
                            formSchema.course_class_timetable_detail,
                        ]}
                    />
                </Pure>
            </ActionModalWrapper>
        </Formik>
    )
}

const CheckInContent = ({item, status_options, onSubmit = NullAsDefault, onCancel = NullAsDefault}) => {
    const t = useTranslate()

    const initialValues = useMemo(
        () => ({
            status_options,
            absent_reason: item?.absent_reason || undefined,
            ...(item ?? {}),
            attendance_state: {
                status: item?.status || undefined,
                number_of_sessions: item?.number_of_sessions,
                absent_reason: item?.absent_reason || undefined
            }
        }),
        [item, status_options]
    )

    const validate = (values) => {
        let errors = {}
        return errors
    }

    return (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={({status_options, attendance_state, ...values}) => {
                const {status, number_of_sessions, absent_reason} = values ?? {}
                onSubmit(
                    _.omitBy(
                        {
                            status,
                            number_of_sessions,
                            absent_reason: absent_reason ?? undefined,
                        },
                        _.isUndefined
                    )
                )
            }}>
            <div className="flex flex-col gap-6">
                <div className="flex flex-col gap-4">
                    <FieldsFactory formSchema={[formSchema.attendance_state]}/>
                </div>
                <div className="flex items-center justify-end p-2 background gap-3">
                    {/*<ResetButton />*/}
                    <SubmitButton
                        label="save"
                        dirtyRequired={false}
                    />
                </div>
            </div>
        </Formik>
    )
}

export const CourseClassAttendantsForm = ({item, attendance, onEdit}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const [current, setCurrent] = useState()

    const [keyword, setKeyword] = useState()
    const [responseItem, setResponseItem] = useState(null)
    const [sub_class_name, setSubClassName] = useState()
    const [statusFilter, setStatusFilter] = useState(null)
    const [absenceRequests, setAbsenceRequests] = useState([])

    const {handleAsyncAction: attendanceCheckIn} = useAsyncAction({
        onError: (error, errorObj) => showErrorDialog(t)({
            error, errorObj,
            icon: <BsQrCodeScan size={20} style={{color: 'var(--color-primary-500)'}} className="anticon"/>,
            closable: true,
            maskClosable: true,
            okText: t('try again'),
            cancelText: t('close'),
            okButtonProps: {
                type: 'default',
                className: 'button-rounded-md no-border bg-primary-50 hover:bg-primary-100 text-primary',
            },
            cancelButtonProps: {
                className: 'button-rounded-md no-border',
            },
            onOk: () => {
                openQRScanner()
            },
            onCancel: () => {
                closeQRScanner()
            },
        }),
        apiInfo: course_class_attendanceCheckIn_Api,
        onSuccess: (result, data) => {
            const dataItem = _.get(data, 'response.data');
            setResponseItem(dataItem);
            closeQRScanner()
        },
    })
    const {qrModal, openQRScanner, isOpenQRScanner, closeQRScanner} = useQrScanner({
        item: attendance,
        timeoutSeconds: 30,
        // QrScanComponent DÙNG CHUNG (chỉ 1 nơi gọi hiện tại, nhưng không hardcode text điểm danh
        // trong component đó) - hint RIÊNG của điểm danh: GV/admin đang cầm máy quét, KHÔNG biết học
        // viên lấy mã QR ở đâu (bạn báo) - chỉ thẳng đường dẫn Cá nhân > Hồ sơ > icon QR cạnh tên.
        hint: t('where to find student QR code hint'),
        doSubmit: (result_text) => {
            if (result_text.includes("|")) {
                const texts = (result_text || "").split("|")
                attendanceCheckIn({
                    ref_type: (texts[0] ?? null),
                    ref_id: (texts[1] ?? null)
                }, {attendance_id: attendance?.id})
            } else {
                const typeId = extractTypeAndIdFromUrl(result_text || "")
                attendanceCheckIn({
                    ref_type: (typeId?.type ?? null),
                    ref_id: (typeId?.id ?? null)
                }, {attendance_id: attendance?.id})
            }
        }
    })

    const {title, course_class, subject} = attendance ?? {}

    // Nội dung kết quả điểm danh - dùng chung cho cả 2 dạng hiển thị bên dưới (bottom sheet mobile /
    // modal desktop), KHÔNG tự vẽ nút đóng ở đây - dialog bọc ngoài (DrawerBottomDialog có sẵn footer
    // "Đóng", Modal desktop dùng nút X có sẵn của antd) đã lo phần đó, tránh lặp 2 nút đóng như trước.
    const renderAttendanceResultContent = () => {
        const {student, number_of_sessions, status} = responseItem ?? {}
        const {avatar, patron_saint_name, fullname, student_idcode, date_of_birth, user} = student ?? {}
        const labelStatus = _.find(attendance_status_options, {value: status})?.label

        return (
            <div className="w-full flex flex-col items-center gap-5 px-1 py-2">
                <div className="relative">
                    <Avatar
                        size={104}
                        src={avatar || getAvatar(user)}
                        icon={<FaUserGraduate size={48} style={{color: '#dedede'}}/>}
                        className="flex flex-center background-200"
                        style={{border: '3px solid #22c55e'}}
                    />
                    <div
                        className="absolute -bottom-1 -right-1 w-7 h-7 rounded-full bg-green-500 border-2 border-white flex flex-center">
                        <IoCheckmarkCircle size={16} className="text-white"/>
                    </div>
                </div>

                <div className="flex flex-col items-center gap-1.5">
                    <span className="text-center font-bold text-xl text-color-000 leading-snug">
                        {[patron_saint_name, fullname].filter(Boolean).join(' ')}
                    </span>
                    <div className="flex items-center gap-2">
                        <span className="font-mono font-semibold text-xs text-blue-600 bg-blue-50 px-2 py-0.5 rounded-full tracking-wider">
                            #{student_idcode}
                        </span>
                        {date_of_birth && (
                            <span className="text-xs text-color-400">
                                {formatDate(date_of_birth, 'DD/MM/YYYY')}
                            </span>
                        )}
                    </div>
                </div>

                <div className="w-full flex items-center gap-2 px-4 py-2.5 rounded-full bg-green-50 border border-green-200">
                    <IoCheckmarkCircle size={18} className="text-green-500 flex-shrink-0"/>
                    <span className="font-semibold text-sm text-green-700 tracking-wide">
                        {t(labelStatus)}
                    </span>
                </div>

                <div className="w-full flex flex-col gap-3 p-3.5 rounded-2xl bg-slate-50">
                    <div className="flex items-center gap-2.5">
                        <IoSchoolOutline size={16} className="text-indigo-400 flex-shrink-0"/>
                        <div className="flex flex-col min-w-0">
                            <span className="text-2xs font-semibold text-slate-400 uppercase tracking-wider">
                                {t('classes')}
                            </span>
                            <span className="font-medium text-sm text-color-100 truncate">
                                {getTitle(course_class)}
                            </span>
                        </div>
                    </div>
                    <div className="flex items-center gap-2.5">
                        <IoCalendarOutline size={16} className="text-orange-400 flex-shrink-0"/>
                        <div className="flex flex-col min-w-0">
                            <span className="text-2xs font-semibold text-slate-400 uppercase tracking-wider">
                                {t('lesson on')}
                            </span>
                            <span className="font-medium text-sm text-color-100 truncate">
                                {title}
                            </span>
                        </div>
                    </div>
                    <div className="flex items-center gap-2.5">
                        <IoBookOutline size={16} className="text-primary flex-shrink-0"/>
                        <div className="flex flex-col min-w-0">
                            <span className="text-2xs font-semibold text-slate-400 uppercase tracking-wider">
                                {t('subjects')}
                            </span>
                            <span className="font-medium text-sm text-color-100 truncate">
                                {getTitle(subject)} - {number_of_sessions} {t('sessions')}
                            </span>
                        </div>
                    </div>
                </div>

                <button
                    onClick={() => {
                        setResponseItem(null);
                        openQRScanner();
                    }}
                    className="w-full h-11 rounded-xl font-semibold text-sm text-white bg-green-500 hover:bg-green-600 active:scale-[0.98] transition-all flex items-center justify-center gap-2">
                    <BsQrCodeScan size={15}/>
                    {t('continue attendance')}
                </button>
            </div>
        )
    }

    // Mobile: bottom sheet (vuốt xuống để đóng, có sẵn nút "Đóng" footer chuẩn của app) - đúng
    // convention DrawDialog đang dùng khắp nơi khác, phù hợp hơn Modal giữa màn hình cho thao tác lặp
    // lại liên tục (quét từng học viên) trên điện thoại. Desktop giữ Modal căn giữa + nút X có sẵn
    // của antd (đủ dùng, không cần thêm nút đóng riêng).
    const qrResultModal = isSm ? (
        <DrawerBottomDialog
            isToggle={!!responseItem}
            toggle={(value) => { if (!value) setResponseItem(null) }}
            title={
                <span className="font-bold text-sm text-color-000 uppercase tracking-wide">
                    {t('attendance of students')}
                </span>
            }>
            {() => renderAttendanceResultContent()}
        </DrawerBottomDialog>
    ) : (
        <Modal
            title={
                <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                    {t('attendance of students')}
                </div>
            }
            width={420}
            className="custom-modal"
            open={!!responseItem}
            onCancel={() => setResponseItem(null)}
            maskClosable={false}
            destroyOnHidden={true}
            footer={null}>
            {renderAttendanceResultContent()}
        </Modal>
    );

    const onCancel = () => {
        setCurrent(null)
    }
    const attendance_id = getId(attendance)
    const {number_of_students} = item ?? {}

    const {handleAsyncAction: fetchAbsenceRequestsForDate} = useAsyncAction({
        apiInfo: course_class_getAbsenceRequestsForDate_Api,
        onSuccess: (__, data) => {
            setAbsenceRequests(getResponseItems(data?.response) || [])
        },
    })

    useEffect(() => {
        if (attendance_id && attendance?.attendance_date && item?.id) {
            fetchAbsenceRequestsForDate(
                {attendance_date: attendance.attendance_date},
                {id: item.id}
            )
        }
    }, [attendance_id])
    const apiInfo = course_class_getAttendanceDetails_Api
    const refreshKey = useMemo(
        () =>
            [
                apiInfo.path.replace(':id', attendance_id),
                JSON.stringify(keyword),
                sub_class_name,
                statusFilter,
            ].join('/'),
        [keyword, sub_class_name, statusFilter, attendance_id]
    )

    const status_options = [
        attendance_status_options.present,
        attendance_status_options.absent,
        attendance_status_options.absent_reason,
    ]

    const {handleAsyncAction: setAttendanceStatus} = useAsyncAction({
        onError: notifyOnError(t),
        apiInfo: course_class_setAttendanceStatus_Api,
        // onSuccess: (result, data) => {
        //   successNotify(NotificationActionTypes.INFORMATION, t)
        // },
    })

    const onSearch = _.debounce((keyword) => {
        setKeyword(keyword)
    }, 500)

    const renderActions = useCallback(
        (item) => {
            const STATUS_PARAMS = {
                1:   {type: 'dashed', style: {color: 'green'},  label: 'attended'},
                0:   {type: 'dashed', style: {color: 'grey'},   label: attendance_status_options.reset.label},
                '-1': {type: 'dashed', style: {color: 'rgba(251,146,60)'}, label: attendance_status_options.absent_reason.label},
                '-2': {type: 'dashed', style: {color: 'red'},    label: attendance_status_options.absent.label},
                '-3': {type: 'dashed', style: {color: 'rgb(202,138,4)'}, label: 'late'},
            }
            const params = STATUS_PARAMS[String(item?.status)] ?? {type: 'dashed', style: {color: 'grey'}, label: attendance_status_options.reset.label}

            return (
                <Button
                    size="small"
                    name="status"
                    style={{width: 'fit-content', border: 0, height: 22, padding: '0 10px'}}
                    className="flex flex-center button-rounded-md font-medium text-xs italic border-transparent hover:border-current leading-tight"
                    {...params}
                    onClick={(e) => {
                        e.preventDefault()
                        setCurrent(Object.assign({}, item))
                    }}>
                    {t(params.label)}
                </Button>
            )
        },
        [attendance_id]
    )

    const {student} = current ?? {}

    return renderIf(
        attendance_id,
        <div className="flex flex-col space-y-3 p-3 relative">
            <div className="mb-3 px-4 py-3 flex flex-col border border-color-50 background shadow-md rounded-2xl">
                <div className="flex items-center justify-between gap-2">
                    <span className="font-semibold text-sm text-slate-700 tracking-wider">
                        {t('lesson information')}
                    </span>
                    {/* Sửa thông tin buổi điểm danh (tựa đề/môn/số tiết/ngày) - ĐẶT ở header màn hình
                        checklist học viên này (không phải nút riêng ở lịch học nữa) - bấm "Sửa điểm
                        danh" giờ vào THẲNG đây để điểm danh tiếp (bạn báo), sửa metadata là việc phụ
                        nằm gọn trong header. onEdit chỉ được truyền khi attendance.edit = true (admin/
                        GV lớp - xem AttendanceTransformer::transform, useCourseAttendances.js). */}
                    {onEdit && (
                        <button
                            type="button"
                            onClick={onEdit}
                            className="flex items-center gap-1 px-2 py-1 rounded-md text-xs font-semibold text-color-300 hover:text-primary hover:bg-primary-50 border-0 bg-transparent cursor-pointer flex-shrink-0">
                            <MdEdit size={13}/>
                            {t('edit')}
                        </button>
                    )}
                </div>
                <div style={{height: 3}} className="mt-1 mb-2 w-20 rounded-full bg-gray-400"/>
                <div className="flex flex-col gap-1">
                    <ItemInformation
                        primary={true}
                        showIcon={true}
                        className="text-xs tracking-wider"
                        label="classes"
                        value={getTitle(item)}
                    />
                    <ItemInformation
                        showIcon={true}
                        className="text-xs tracking-wider"
                        label="lesson on"
                        value={getTitle(attendance).split(" - ")[0]}
                    />
                    <ItemInformation
                        showIcon={true}
                        className="text-xs tracking-wider"
                        label="subjects"
                        value={_.get(attendance?.subject, 'title')}
                    />
                    <ItemInformation
                        showIcon={true}
                        className="text-xs tracking-wider"
                        label="number of student"
                        value={`${number_of_students} ${t('students')}`}
                    />
                    <ItemInformation
                        showIcon={true}
                        className="text-xs tracking-wider"
                        label="duration"
                        value={`${attendance?.number_of_sessions} ${t('sessions')}`}
                    />
                </div>
            </div>
            {absenceRequests.length > 0 && (
                <div className="rounded-xl border border-amber-200 bg-amber-50 overflow-hidden">
                    <div className="px-3 py-2 flex items-center gap-2 bg-amber-100 border-b border-amber-200">
                        <TbAlertTriangle size={13} className="text-amber-600 flex-shrink-0"/>
                        <span className="font-bold text-xs text-amber-700 uppercase tracking-wider flex-1">
                            {t('absence requests for this session')}
                        </span>
                        <span className="px-1.5 py-0.5 rounded-full bg-amber-600 text-white text-2xs font-bold leading-none">
                            {absenceRequests.length}
                        </span>
                    </div>
                    <div className="divide-y divide-amber-100">
                        {absenceRequests.map(req => {
                            const {student, from_date, to_date, reason_group, reason, absence_type, schedule} = req
                            const dateLabel = (() => {
                                if (absence_type === 1 && schedule?.start_time) {
                                    const start = dayjs(schedule.start_time)
                                    const end = schedule.end_time ? dayjs(schedule.end_time) : null
                                    return `${start.format('DD/MM/YYYY')} · ${end ? `${start.format('HH:mm')} – ${end.format('HH:mm')}` : start.format('HH:mm')}`
                                }
                                const isSameDay = dayjs(from_date).isSame(dayjs(to_date), 'day')
                                const fmt = d => dayjs(d).format('DD/MM/YYYY')
                                return isSameDay ? fmt(from_date) : `${fmt(from_date)} – ${fmt(to_date)}`
                            })()
                            return (
                                <div key={req.id} className="px-3 py-2 flex items-start gap-2.5">
                                    <Avatar
                                        size={30}
                                        src={student?.avatar || getAvatar(student?.user)}
                                        icon={<FaUserGraduate size={14} className="text-color-400"/>}
                                        className="flex-shrink-0 flex flex-center background-200 rounded-full"
                                    />
                                    <div className="flex-1 min-w-0">
                                        <span className="font-bold text-sm text-color-000 leading-tight block">
                                            {student?.fullname || '—'}
                                        </span>
                                        {student?.student_idcode && (
                                            <span className="text-2xs font-mono text-amber-600">
                                                #{student.student_idcode}
                                            </span>
                                        )}
                                        <div className="mt-0.5 flex items-center gap-1 text-xs text-color-400">
                                            <IoCalendarOutline size={10} className="text-amber-400 flex-shrink-0"/>
                                            <span>{dateLabel}</span>
                                        </div>
                                        {(reason_group || reason) && (
                                            <div className="mt-0.5 text-xs italic text-color-300 leading-tight">
                                                {reason_group && <span className="font-medium not-italic text-color-400">{reason_group}{reason ? ': ' : ''}</span>}
                                                {reason}
                                            </div>
                                        )}
                                    </div>
                                    <span className="flex-shrink-0 mt-0.5 text-2xs font-semibold px-1.5 py-0.5 rounded bg-amber-100 text-amber-700 border border-amber-200">
                                        {absence_type === 1 ? t('by session') : t('by date range')}
                                    </span>
                                </div>
                            )
                        })}
                    </div>
                </div>
            )}
            {!!responseItem && qrResultModal}
            {isOpenQRScanner && qrModal}
            {/* Trước đây chỉ vẽ nút này trên mobile (isSm) - laptop/desktop (vd đang test responsive
                1281px) KHÔNG CÓ đường nào mở scanner cả (bạn báo không biết bấm đâu để quét) - camera
                laptop/webcam vẫn quét được bình thường (QrScanComponent dùng getUserMedia chung, không
                phân biệt thiết bị), không có lý do gì phải giấu nút này khỏi desktop. */}
            <button
                onClick={openQRScanner}
                className="w-full flex items-center gap-4 px-4 py-3.5 rounded-xl border border-primary bg-primary-50 hover:bg-primary-100 active:scale-95 transition-all cursor-pointer">
                <div className="relative flex-shrink-0">
                    <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center">
                        <IoQrCodeOutline size={22} className="text-white"/>
                    </div>
                    <span className="w-3 h-3 absolute bottom-0 right-0 rounded-full bg-green-400 border-2 border-white"/>
                </div>
                <div className="flex flex-col items-start gap-0.5 flex-1 min-w-0">
                    <span className="font-bold text-sm text-primary leading-tight">
                        {t('check in')}
                    </span>
                    <span className="text-2xs text-primary opacity-70 leading-tight">
                        {t('scan qr code to attendance')}
                    </span>
                </div>
                <IoQrCodeOutline size={16} className="text-primary opacity-40 flex-shrink-0"/>
            </button>
            <div className="flex flex-col space-y-3">
                <Input.Search
                    name="keyword"
                    autoComplete="off"
                    allowClear={true}
                    onSearch={onSearch}
                    placeholder={t('type to search')}
                    className="input-search-with-icon"
                    onChange={(event) => {
                        onSearch(event.target?.value)
                    }}
                />
                <SubClassTags
                    items={_.get(item, 'sub_class_names', [])}
                    selected={sub_class_name}
                    setSelected={setSubClassName}
                />
            </div>
            <div className="flex flex-col gap-3">
                <div className="flex items-center justify-between gap-2 flex-wrap">
                    <span className="font-semibold text-xs text-color-300 uppercase tracking-wider">
                        {t('list of students')}
                    </span>
                    <div className="flex items-center gap-1 flex-wrap">
                        {[
                            {value: null, label: t('all')},
                            {value: 1, label: t('attended'), color: statusFilter === 1 ? 'bg-green-500 text-white' : 'bg-green-50 text-green-700 hover:bg-green-100'},
                            {value: -3, label: t('late'), color: statusFilter === -3 ? 'bg-yellow-500 text-white' : 'bg-yellow-50 text-yellow-700 hover:bg-yellow-100'},
                            {value: -1, label: t('excused absence'), color: statusFilter === -1 ? 'bg-orange-400 text-white' : 'bg-orange-50 text-orange-600 hover:bg-orange-100'},
                            {value: -2, label: t('unexcused absence'), color: statusFilter === -2 ? 'bg-red-500 text-white' : 'bg-red-50 text-red-600 hover:bg-red-100'},
                        ].map((opt) => (
                            <button
                                key={String(opt.value)}
                                onClick={() => setStatusFilter(opt.value)}
                                style={{height: 24, padding: '0 10px'}}
                                className={classNames(
                                    "flex flex-center text-2xs font-semibold rounded-full transition-all leading-snug",
                                    opt.value === null
                                        ? statusFilter === null
                                            ? 'bg-gray-300 text-gray-700'
                                            : 'background-100 text-color-300 hover:background-200'
                                        : opt.color
                                )}>
                                {opt.label}
                            </button>
                        ))}
                    </div>
                </div>
                {/* Nút trạng thái (renderActions ở trên) tự nó không đủ rõ là bấm được - thêm mô tả
                    ngắn ngay trên bảng để GV/admin biết có thể đổi trực tiếp, không cần mở modal Sửa. */}
                <p className="text-2xs text-color-400 italic leading-relaxed -mt-1">
                    {t('click attendance status hint')}
                </p>
                <EntityList
                    apiInfo={apiInfo}
                    values={{keyword, sub_class_name, status: statusFilter}}
                    refreshKey={refreshKey}
                    query={bindQueryParam({id: attendance_id})}
                    renderItem={renderAttendantDetail({renderActions})}
                    renderWrap={(children) => (
                        <div className="border border-color-100 rounded-lg overflow-hidden">
                            <div className="grid items-center text-2xs font-bold text-color-400 uppercase tracking-wider px-3 py-2 background-100 border-b border-color-100"
                                 style={{gridTemplateColumns: isSm ? '1fr auto' : '1fr 110px 64px 130px'}}>
                                <span>{t('student')}</span>
                                {!isSm && <span className="text-center">{t('subclass title')}</span>}
                                {!isSm && <span className="text-center">{t('sessions')}</span>}
                                <span className="text-center">{t('status')}</span>
                            </div>
                            <div>{children}</div>
                        </div>
                    )}
                />
            </div>
            {current && (
                <Modal
                    footer={null}
                    open={current}
                    onCancel={onCancel}
                    destroyOnHidden={true}
                    className="custom-modal"
                    title={
                        <div className="text-center text-color-000 font-bold uppercase">
                            {t('attendance')}
                        </div>
                    }>
                    <div className="flex flex-col gap-4">
                        <div className="px-3 py-2 border border-color-50 shadow-md rounded-xl flex flex-col">
                            <span className="font-semibold text-slate-700 tracking-wider">
                                {t('student information')}
                            </span>
                            <div style={{height: 3}} className="mt-0.5 mb-2 w-20 rounded-full bg-gray-400"/>
                            <div className="flex items-center gap-3">
                                <Avatar
                                    size={46}
                                    src={student?.avatar || student?.user?.avatar}
                                    icon={<FaUserGraduate size={16} className="text-color-500"/>}
                                    className="flex flex-center background-200"
                                />
                                <div className="flex flex-col gap-0.5">
                                    <span className="font-bold text-base text-color-000">
                                        {student?.prefix_title || student?.patron_saint_name || ''} {getTitle(student)}
                                    </span>
                                    <div className="flex items-center gap-6">
                                        {renderIf(
                                            student?.student_idcode,
                                            <div className="text-xs tracking-wider">
                                                {!isSm && (
                                                    <span className="text-color-400 italic whitespace-no-wrap">
                                                        {`${t('student code')} : `}
                                                    </span>
                                                )}
                                                <span
                                                    onClick={() => {
                                                        copyToClipboard(student?.student_idcode)
                                                        message.info(t('copied'))
                                                    }}
                                                    className="font-semibold text-blue-500 hover:text-blue-600 cursor-pointer">
                                                    #{student?.student_idcode}
                                                    <IoCopyOutline size={12} className="ml-1"/>
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <CheckInContent
                            item={current}
                            status_options={status_options}
                            onSubmit={(values) => {
                                setAttendanceStatus(values, {
                                    attendance_id,
                                    detail_id: getId(current),
                                })
                                onCancel()
                            }}
                            onCancel={onCancel}
                        />
                    </div>
                </Modal>
            )}
        </div>
    )
}

export const CourseClassStudentAttendantsForm = ({courseClass, student}) => {
    const t = useTranslate()

    const [current, setCurrent] = useState()

    const [keyword, setKeyword] = useState()

    const onCancel = () => {
        setCurrent(null)
    }

    const apiInfo = course_class_getAttendanceDetailsByStudent_Api

    const refreshKey = useMemo(
        () =>
            [
                apiInfo.path
                    .replace(':id', courseClass?.id)
                    .replace(':student_id', student?.id),
                JSON.stringify(keyword),
            ].join('/'),
        [keyword, courseClass, student]
    )

    const status_options = [
        attendance_status_options.absent,
        attendance_status_options.absent_reason,
    ]

    const {handleAsyncAction: setAttendanceStatus} = useAsyncAction({
        onError: notifyOnError(t),
        apiInfo: course_class_setAttendanceStatus_Api,
        // onSuccess: (result, data) => {
        //   successNotify(NotificationActionTypes.INFORMATION, t)
        // },
    })

    const onSearch = _.debounce((keyword) => {
        setKeyword(keyword)
    }, 500)

    const renderActions = useCallback(
        (item) => {
            let params = {}
            if (item?.status === 1) {
                params.type = 'dashed'
                params.style = {color: 'green', borderColor: 'green'}
                params.label = attendance_status_options.present.label
            }
            if (item?.status === 0) {
                params.type = 'dashed'
                params.style = {color: 'grey', borderColor: 'grey'}
                params.label = attendance_status_options.reset.label
            }
            if (item?.status === -1) {
                params.danger = true
                params.type = 'dashed'
                params.style = {color: 'orange', borderColor: 'orange'}
                params.label = attendance_status_options.absent_reason.label
            }
            if (item?.status === -2) {
                params.danger = true
                params.type = 'dashed'
                params.style = {color: 'red', borderColor: 'red'}
                params.label = attendance_status_options.absent.label
            }
            if (item?.status === -3) {
                params.type = 'dashed'
                params.style = {color: 'dodgerblue', borderColor: 'dodgerblue'}
                params.label = attendance_status_options.late.label
            }
            return (
                <Button
                    className="button-rounded-xs font-semibold text-xs border-transparent hover:border-current"
                    size="small"
                    name="status"
                    {...params}
                    onClick={(e) => {
                        e.preventDefault()
                        setCurrent(Object.assign({}, item))
                    }}>
                    {t(params?.label)}
                </Button>
            )
        },
        [courseClass, student]
    )

    const {attendance, number_of_sessions} = current ?? {}

    const {
        fullname,
        prefix_title,
        patron_saint_name,
        contact_phone,
        contact_email,
        contact_address,
        gender,
        date_of_birth,
        place_of_birth,
        parish,
        religious_order,
        religious_order_name,
    } = student ?? {}

    return renderIf(
        courseClass && student,
        <div className="flex flex-col gap-3 p-3">
            <div className="mb-3 px-4 py-3 flex flex-col border border-color-50 background shadow-md rounded-2xl">
                <span className="font-semibold text-sm text-slate-700 tracking-wider">
                    {t('student information')}
                </span>
                <div style={{height: 3}} className="mt-1 mb-2 w-20 rounded-full bg-gray-400"/>
                <div className="flex flex-col gap-1">
                    <ItemInformation
                        primary={true} showIcon={true}
                        className="text-xs tracking-wider" label="full name"
                        value={`${prefix_title || patron_saint_name || ''} ${fullname}`}
                    />
                    <ItemInformation
                        showIcon={true}
                        className="text-xs tracking-wider" label="gender"
                        value={t(getLabelOfGender(gender))}
                    />
                    <DatePlaceItem
                        showIcon={true}
                        label="date of birth"
                        date={date_of_birth ? formatDate(date_of_birth, 'DD/MM/YYYY') : t('not update')}
                        place={place_of_birth}
                        className="text-xs tracking-wider"
                    />
                    <DoubleValueItem
                        showIcon={true}
                        labelFirst={t('contact')} valueFirst={contact_phone}
                        labelSecond={contact_email && " - " || ''} valueSecond={contact_email}
                        className="text-xs tracking-wider"
                    />
                    <ItemInformation
                        showIcon={true}
                        label="address" value={contact_address}
                        className="text-xs tracking-wider"
                    />
                    {renderIf(
                        parish,
                        <DoubleValueItem
                            showIcon={true}
                            labelFirst="parish"
                            valueFirst={parish?.name}
                            labelSecond={_.get(parish, 'diocese_fullname') ? ' - ' : ''}
                            valueSecond={_.get(parish, 'diocese_fullname')}
                            className="text-xs tracking-wider"
                        />
                    )}
                    {renderIf(
                        religious_order_name,
                        <ItemInformation
                            showIcon={true}
                            label="belong to religious order"
                            value={
                                <Link to={getLinkToDetail(religious_order)} className="no-underline">
                                    {religious_order_name}
                                </Link>
                            }
                            className="text-xs tracking-wider"
                        />
                    )}
                </div>
            </div>
            <div className="flex flex-col gap-3">
                <div className="flex flex-col">
                    <span className="font-semibold text-sm text-slate-700 tracking-wider">
                        {t('list of lesson')}
                    </span>
                    <div style={{height: 3}} className="my-1 w-20 rounded-full bg-gray-400"/>
                    <span className="text-xs text-color-400 italic tracking-wider">
                        {`* ${t('list of lesson description')}`}
                    </span>
                </div>
                <EntityList
                    apiInfo={apiInfo}
                    values={{keyword}}
                    refreshKey={refreshKey}
                    query={bindQueryParams([
                        {id: courseClass?.id},
                        {student_id: student?.id},
                    ])}
                    renderItem={renderAttendantDetail({
                        renderActions,
                        primary_type: 'attendance',
                    })}
                />
            </div>
            {renderIf(
                current,
                <Modal
                    footer={null}
                    open={current}
                    onCancel={onCancel}
                    destroyOnHidden={true}
                    className="custom-modal"
                    title={
                        <div className="text-center text-color-000 font-bold uppercase">
                            {t('attendance')}
                        </div>
                    }>
                    <div className="flex flex-col gap-4">
                        <div className="mb-3 px-4 py-3 flex flex-col border border-color-50 background shadow-md rounded-2xl">
                            <span className="font-semibold text-sm text-slate-700 tracking-wider">
                                {t('lesson information')}
                            </span>
                            <div style={{height: 3}} className="mt-1 mb-2 w-20 rounded-full bg-gray-400"/>
                            <div className="flex flex-col gap-1">
                                <ItemInformation
                                    primary={true}
                                    showIcon={true}
                                    label="lesson on" value={getTitle(attendance)}
                                    className="text-xs tracking-wider"
                                />
                                <ItemInformation
                                    showIcon={true}
                                    label="number of sessions" value={`${number_of_sessions} ${t('sessions')}`}
                                    className="text-xs tracking-wider"
                                />
                                <ItemInformation
                                    showIcon={true}
                                    label="subjects" value={getTitle(_.get(attendance, 'subject'))}
                                    className="text-xs tracking-wider"
                                />
                            </div>
                        </div>
                        <CheckInContent
                            item={current}
                            status_options={status_options}
                            onSubmit={(values) => {
                                setAttendanceStatus(values, {
                                    attendance_id: current?.attendance?.id,
                                    detail_id: getId(current),
                                })
                                onCancel()
                            }}
                        />
                    </div>
                </Modal>
            )}
        </div>
    )
}


const renderAttendanceStats = ({renderActions} = {}) => (item, index) => {

    const AVATAR_COLORS = ['bg-indigo-500', 'bg-green-500', 'bg-red-400', 'bg-yellow-500', 'bg-purple-500', 'bg-blue-500', 'bg-pink-500', 'bg-teal-500']
    const getAvatarColor = (str = '') => {
        let hash = 0
        for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash)
        return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
    }

    const {student, number_of_sessions, total_sessions, passed_attendance_status, eligibility_status} = item ?? {}
    const {prefix_title, fullname} = student ?? {}

    const pct = number_of_sessions > 0
        ? parseFloat(((total_sessions / number_of_sessions) * 100).toFixed(1))
        : 0

    let barColor = 'bg-color-200'
    let pctColor = 'text-color-300'
    if (pct >= 75) { barColor = 'bg-green-500'; pctColor = 'text-green-600' }
    else if (pct >= 50) { barColor = 'bg-blue-500'; pctColor = 'text-blue-500' }
    else if (pct > 0) { barColor = 'bg-red-400'; pctColor = 'text-red-500' }

    let statusLabel, statusColor, statusBg
    switch (passed_attendance_status) {
        case 1:
            statusLabel = 'passed'
            statusColor = 'text-green-700'
            statusBg = 'bg-green-50'
            break
        case 0:
            statusLabel = 'failed'
            statusColor = 'text-red-600'
            statusBg = 'bg-red-50'
            break
        default:
            statusLabel = 'not assessed yet'
            statusColor = 'text-color-300'
            statusBg = 'bg-color-50'
            break
    }
    return (
        <Translate key={index}>
            {(t) => (
                <div className="p-3 flex items-center gap-3 transition-all duration-300">
                    {(student?.avatar || student?.user?.avatar) ? (
                        <Avatar
                            src={student?.avatar || student?.user?.avatar}
                            className="flex flex-center"
                        />
                    ) : (
                        <div
                            style={{ width: 32, height: 32 }}
                            className={classNames(
                                'rounded-full flex flex-center text-white text-xs font-bold flex-shrink-0',
                                getAvatarColor(fullname))
                            }>
                            {fullname.charAt(0).toUpperCase()}
                        </div>
                    )}
                    <div className="flex items-center flex-1 gap-1 min-w-0">
                        <div className="flex flex-col gap-1 flex-1">
                            <div className="font-semibold text-sm text-color-000 truncate tracking-wide">
                                {(prefix_title || student?.patron_saint_name) && (
                                    <span className="mr-1 font-medium text-slate-500">
                                    {prefix_title || student?.patron_saint_name}
                                </span>
                                )}
                                {fullname}
                            </div>
                            <div className="bg-gray-100 rounded-full overflow-hidden" style={{height: 5}}>
                                <div
                                    className={classNames('h-full rounded-full transition-all', barColor)}
                                    style={{width: `${Math.min(pct, 100)}%`}}
                                />
                            </div>
                        </div>
                        <div className="flex flex-col items-center">
                            <span className="font-medium text-xs text-color-300 flex-shrink-0 tracking-wider">
                                {`(${total_sessions}/${number_of_sessions})`}
                            </span>
                            <span className={classNames('text-xs font-bold tabular-nums flex-shrink-0', pctColor)} style={{minWidth: 36, textAlign: 'right'}}>
                                {`${pct}%`}
                            </span>
                        </div>
                    </div>
                    <div className="flex flex-col items-end gap-1 flex-shrink-0">
                        <span className={classNames('text-2xs font-semibold px-2 py-0.5 rounded-full', statusBg, statusColor)}>
                            {t(statusLabel)}
                        </span>
                        {eligibility_status ? (
                            <span className="text-2xs font-semibold px-2 py-0.5 rounded-full bg-green-100 text-green-600">
                                {t('eligible has been granted')}
                            </span>
                        ) : (
                            <span className="text-2xs text-color-400">—</span>
                        )}
                    </div>
                </div>
            )}
        </Translate>
    )
}

export const CourseClassStudentAttendanceStats = ({courseClass}) => {
    const t = useTranslate()
    const [rateFilter, setRateFilter] = useState(null)

    const classSubjects = useMemo(
        () => (courseClass?.class_subjects ?? []).filter(cs => !!cs?.subject),
        [courseClass]
    )

    const [selectedSubjectId, setSelectedSubjectId] = useState(
        () => String(getId(classSubjects[0]?.subject) ?? '') || null
    )

    const selectedCs = useMemo(
        () => classSubjects.find(cs => String(getId(cs.subject)) === String(selectedSubjectId)),
        [classSubjects, selectedSubjectId]
    )

    const passed_attendance_percentage = selectedCs?.passed_attendance_percentage

    const [keyword, setKeyword] = useState('')

    const onSearch = useMemo(
        () => _.debounce((val) => setKeyword(val ?? ''), 400),
        []
    )

    const handleSelectSubject = useCallback((id) => {
        const sid = String(id)
        setSelectedSubjectId(sid)
        setRateFilter(null)
        setKeyword('')
    }, [])

    const apiInfo = course_class_student_getAttendanceResult_Api

    const refreshKey = useMemo(
        () => [
            apiInfo.path
                .replace(':course_class_id', courseClass?.id)
                .replace(':subject_id', selectedSubjectId),
            rateFilter,
            keyword,
        ].join('/'),
        [courseClass, selectedSubjectId, rateFilter, keyword]
    )

    const eligibilityFilters = useMemo(() => {
        const filters = [{value: null, label: t('all'), color: null}]
        if (passed_attendance_percentage > 0 && passed_attendance_percentage <= 100) {
            filters.push({
                value: `${passed_attendance_percentage}-100`,
                label: `≥${passed_attendance_percentage}%`,
                sublabel: t('eligible'),
                color: 'green',
            })
            filters.push({
                value: `0-${passed_attendance_percentage}`,
                label: `<${passed_attendance_percentage}%`,
                sublabel: t('not yet eligible'),
                color: 'red',
            })
        }
        return filters
    }, [passed_attendance_percentage, t])

    return (
        <div className="flex flex-col gap-4">
            {/* Subject pill selector — dùng class_subjects đã có sẵn, không gọi thêm API */}
            {classSubjects.length > 0 && (
                <div className="flex flex-col gap-1.5">
                    <span className="text-xs text-color-400 italic">{`${t('subjects')} :`}</span>
                    <div className="flex flex-wrap gap-1.5">
                        {classSubjects.map((cs) => {
                            const sid = String(getId(cs.subject))
                            const isActive = sid === String(selectedSubjectId)
                            const pct = cs.passed_attendance_percentage
                            return (
                                <button
                                    key={sid}
                                    onClick={() => handleSelectSubject(sid)}
                                    style={{height: 30}}
                                    className={classNames(
                                        'flex items-center gap-1.5 px-3 text-xs font-semibold rounded-lg transition-all duration-300 select-none',
                                        isActive
                                            ? 'bg-indigo-600 border-indigo-600 text-white'
                                            : 'border border-color-200 hover:border-indigo-400 background text-color-300 hover:text-indigo-500'
                                    )}>
                                    <span>{getTitle(cs.subject)}</span>
                                    {pct > 0 && (
                                        <span className={classNames('text-2xs font-normal', isActive ? 'text-indigo-200' : 'text-color-400')}>
                                            {`≥${pct}%`}
                                        </span>
                                    )}
                                </button>
                            )
                        })}
                    </div>
                </div>
            )}

            {/* Filter eligibility — chỉ hiện khi đã chọn môn có threshold */}
            {selectedSubjectId && passed_attendance_percentage > 0 && (
                <div className="flex flex-col gap-1.5">
                    <span className="text-xs text-color-400 italic">
                        {`${t('filter by range of values')} :`}
                    </span>
                    <div className="flex flex-wrap gap-1.5">
                        {eligibilityFilters.map((f, i) => {
                            const isActive = rateFilter === f.value
                            let cls = isActive
                                ? f.color === 'green' ? 'bg-green-600 border-green-600 text-white'
                                    : f.color === 'red' ? 'bg-red-500 border-red-500 text-white'
                                        : 'bg-indigo-600 border-indigo-600 text-white'
                                : f.color === 'green' ? 'border-color-200 text-green-600 hover:border-green-500'
                                    : f.color === 'red' ? 'border-color-200 text-red-500 hover:border-red-400'
                                        : 'border-color-200 text-color-300 hover:border-indigo-400 hover:text-indigo-500'
                            return (
                                <button
                                    key={i}
                                    onClick={() => setRateFilter(isActive ? null : f.value)}
                                    className={classNames(
                                        'px-3 py-1 text-xs font-medium rounded-full border transition-colors select-none',
                                        cls
                                    )}>
                                    {f.label}
                                    {f.sublabel && (
                                        <span className="ml-1 opacity-75">{`· ${f.sublabel}`}</span>
                                    )}
                                </button>
                            )
                        })}
                    </div>
                    <span className="text-xs text-green-600 font-medium italic">
                        {`* ${t('passed attendance percentage')} : ${passed_attendance_percentage}%`}
                    </span>
                </div>
            )}

            {/* Danh sách học viên — chỉ render khi đã chọn môn */}
            {selectedSubjectId ? (
                <div className="flex flex-col gap-2">
                    <span className="font-semibold text-sm text-color-400 uppercase tracking-wider">
                        {t('list of students')}
                    </span>
                    <Input.Search
                        allowClear={true}
                        autoComplete="off"
                        className="input-search-with-icon"
                        placeholder={t('search by name, student code, id card')}
                        onChange={(e) => onSearch(e.target.value)}
                        onSearch={onSearch}
                    />
                    <div className="flex flex-col divide-y divide-gray-200 list-item-workspace">
                        <EntityList
                            apiInfo={apiInfo}
                            key={refreshKey}
                            query={bindQueryParams([
                                {course_class_id: courseClass?.id},
                                {subject_id: selectedSubjectId},
                            ])}
                            values={{range: rateFilter, keyword: keyword || undefined}}
                            renderEmpty={renderEmptyHolder}
                            renderItem={renderAttendanceStats({})}
                            RenderEntity={React.Fragment}
                        />
                    </div>
                </div>
            ) : (
                <EmptyHolder title={t('please select a subject')}/>
            )}
        </div>
    )
}